// ----------------------------------------------------------------------

declare module '@mui/system/createTheme/shape' {
	interface Shape {
		borderRadiusSm: number | string;
		borderRadiusMd: number | string;
		borderRadiusLg: number | string;
		borderRadiusXl: number | string;
	}
}

const shape = {
	borderRadius: 5,
	borderRadiusSm: 12,
	borderRadiusMd: 16,
	borderRadiusLg: 24,
	borderRadiusXl: 40,
};

export default shape;
